import Text from "../../../components/ui/Text";
import Touchable from "../../../components/ui/Touchable";
import { AccountType } from "../types";

export default function ToggleAccountTypeJP({
  accountType,
  onClick,
}: {
  accountType: AccountType;
  onClick: () => void;
}) {
  return (
    <Touchable className="mt-6" onClick={onClick}>
      <Text normal className="border-b border-solid border-black8">
        {accountType === "mail" ? "電話番号を使用" : "メールアドレスを使用"}
      </Text>
    </Touchable>
  );
}
